import { Expose } from 'class-transformer';

export class AppointmentTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
